export const DATE_FORMAT = 'dd/MM/yyyy';

export const ADMIN_GROUP = 'Administrator'
export const POWER_GROUP = 'Power User'
export const STUDY_GROUP = 'Perdorues'

export const MEDIA_TYPES: { [key: number]: string } = {1: 'Audio', 2: 'Video'};
export const USE_TYPES: { [key: number]: string } = {1: 'Personal', 2: 'Transmetim'};

export const AUDIO_TYPE = 1;
export const VIDEO_TYPE = 2;
